import Vue from "vue";
import { MutationTree, GetterTree, ActionTree } from "vuex";

const state = () => ({
  users: {},
  locks: {}
});

export type UserState = ReturnType<typeof state>;

const getters: GetterTree<UserState, {}> = {
  getUserById(state) {
    return id => {
      return state.users[id];
    };
  }
};

const mutations: MutationTree<UserState> = {
  setUser(state, { user, id }) {
    Vue.set(state.users, id, user);
  },
  lock(state, id) {
    Vue.set(state.locks, id, true);
  },
  unLock(state, id) {
    Vue.set(state.locks, id, false);
  }
};

const actions: ActionTree<UserState, {}> = {
  async loadUser({ commit, state }, id) {
    if (!id) {
      return;
    }
    const loaded = state.users[id];
    const locked = state.locks[id];
    if (loaded || locked) {
      return;
    }
    commit("lock", id);
    const user = await this.$api.wallet.mixin.getUser(id);
    commit("setUser", { id, user });
    commit("unLock", id);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
